import {
  GiAfrica,
  GiSouthAmerica,
  GiEarthAsiaOceania,
  GiIraq,
  GiEarthAmerica,
} from "react-icons/gi";

import { FaGlobeEurope, FaGlobeAsia } from "react-icons/fa";

export const destinationIcons = {
  africa: {
    icon: <GiAfrica />,
  },
  asia: {
    icon: <FaGlobeAsia />,
  },
  south_america: {
    icon: <GiSouthAmerica />,
  },
  north_america: {
    icon: <GiEarthAmerica />,
  },
  europe: {
    icon: <FaGlobeEurope />,
  },
  oceania: {
    icon: <GiEarthAsiaOceania />,
  },
  caribbean: {
    icon: <GiEarthAmerica />,
  },
  middle_east: {
    icon: <GiIraq />,
  },
  central_america: {
    icon: <GiEarthAmerica />,
  },
};
